export default "__VITE_ASSET__BU6iaN1D__"